import { render, staticRenderFns } from "./ValentinesDay_drinkSection.vue?vue&type=template&id=baa1825c&scoped=true"
import script from "./ValentinesDay_drinkSection.vue?vue&type=script&lang=ts"
export * from "./ValentinesDay_drinkSection.vue?vue&type=script&lang=ts"
import style0 from "./ValentinesDay_drinkSection.vue?vue&type=style&index=0&id=baa1825c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa1825c",
  null
  
)

export default component.exports